<div class="accordion">
    <mat-accordion
        displayMode="flat"
        style="width: 100px">
        <mat-expansion-panel
            hideToggle
            *ngFor="let leftItems of leftNav; index as lastMenu"
            style="max-width: 330px">
            <mat-expansion-panel-header
                *ngIf="leftItems.permission"
                [collapsedHeight]="'60px'">
                <mat-panel-title style="align-items: center">
                    <a><i class="{{ leftItems.icon }}"></i></a>
                    <span class="accordion__category__main">{{ leftItems.name | translate }}</span>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-accordion>
                <mat-expansion-panel
                    *ngFor="let subItem of leftItems.items"
                    hideToggle="true">
                    <mat-expansion-panel-header
                        *ngIf="subItem.permission"
                        class="accordion__second__panel">
                        <mat-panel-title style="overflow: hidden">
                            <a (click)="subItem.route ? goToUrl(subItem.route, subItem.identifier) : ''"
                                ><span class="accordion__category">{{ subItem.name | translate }}</span></a
                            >
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="accordion__sub__menu">
                        <div [class.accordion__sub__menu-overflowMenu]="lastMenu === 3">
                            <ng-container *ngFor="let subSubItem of subItem.items">
                                <div
                                    *ngIf="subSubItem.permission"
                                    class="accordion__sub__category">
                                    <a (click)="goToUrl(subSubItem.route, subSubItem.identifier)"
                                        ><span>{{ subSubItem.name | translate }}</span></a
                                    >
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </mat-expansion-panel>
        <div class="accordion__logout">
            <a
                (click)="logout()"
                style="display: flex; align-items: center">
                <i class="zmdi zmdi-power"></i>
                <span class="accordion__category__main">Logout</span></a
            >
        </div>
    </mat-accordion>
</div>
